import type { OmniCineHandoffPayload } from "@/lib/guidedStudio/buildOmniCineHandoffPayload";
import type { OmniStudioHandoffPayload } from "@/lib/guidedStudio/buildOmniStudioHandoffPayload";
import type { GuidedWorldForgeHandoffPayload } from "@/lib/guidedStudio/buildWorldForgeHandoffPayload";

export const GUIDED_STUDIO_OMNISTUDIO_HANDOFF_KEY = "guidedStudio.omniStudioHandoff.v1";
export const GUIDED_STUDIO_OMNICINE_HANDOFF_KEY = "guidedStudio.omniCineHandoff.v1";
export const GUIDED_STUDIO_WORLD_FORGE_HANDOFF_KEY = "guidedStudio.worldForgeHandoff.v1";

function stageJson<T>(storageKey: string, payload: T): void {
  if (typeof window === "undefined" || !window.sessionStorage) return;

  window.sessionStorage.setItem(storageKey, JSON.stringify(payload));
}

function readJson<T>(storageKey: string): T | null {
  if (typeof window === "undefined" || !window.sessionStorage) return null;

  const raw = window.sessionStorage.getItem(storageKey);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as T;
  } catch {
    window.sessionStorage.removeItem(storageKey);
    return null;
  }
}

function clearJson(storageKey: string): void {
  if (typeof window === "undefined" || !window.sessionStorage) return;

  window.sessionStorage.removeItem(storageKey);
}

function consumeJson<T>(storageKey: string): T | null {
  const payload = readJson<T>(storageKey);
  if (!payload) return null;

  clearJson(storageKey);
  return payload;
}

export function readStagedOmniStudioHandoffPayload(): OmniStudioHandoffPayload | null {
  return readJson<OmniStudioHandoffPayload>(GUIDED_STUDIO_OMNISTUDIO_HANDOFF_KEY);
}

export function clearStagedOmniStudioHandoffPayload(): void {
  clearJson(GUIDED_STUDIO_OMNISTUDIO_HANDOFF_KEY);
}

export function consumeStagedOmniStudioHandoffPayload(): OmniStudioHandoffPayload | null {
  return consumeJson<OmniStudioHandoffPayload>(GUIDED_STUDIO_OMNISTUDIO_HANDOFF_KEY);
}

export function stageOmniStudioHandoffPayload(payload: OmniStudioHandoffPayload): void {
  stageJson(GUIDED_STUDIO_OMNISTUDIO_HANDOFF_KEY, payload);
}

export function consumeStagedOmniCineHandoffPayload(): OmniCineHandoffPayload | null {
  return consumeJson<OmniCineHandoffPayload>(GUIDED_STUDIO_OMNICINE_HANDOFF_KEY);
}

export function stageOmniCineHandoffPayload(payload: OmniCineHandoffPayload): void {
  stageJson(GUIDED_STUDIO_OMNICINE_HANDOFF_KEY, payload);
}

export function readStagedGuidedWorldForgeHandoffPayload(): GuidedWorldForgeHandoffPayload | null {
  return readJson<GuidedWorldForgeHandoffPayload>(GUIDED_STUDIO_WORLD_FORGE_HANDOFF_KEY);
}

export function clearStagedGuidedWorldForgeHandoffPayload(): void {
  clearJson(GUIDED_STUDIO_WORLD_FORGE_HANDOFF_KEY);
}

export function consumeStagedGuidedWorldForgeHandoffPayload(): GuidedWorldForgeHandoffPayload | null {
  return consumeJson<GuidedWorldForgeHandoffPayload>(GUIDED_STUDIO_WORLD_FORGE_HANDOFF_KEY);
}

export function stageGuidedWorldForgeHandoffPayload(payload: GuidedWorldForgeHandoffPayload): void {
  stageJson(GUIDED_STUDIO_WORLD_FORGE_HANDOFF_KEY, payload);
}